import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { getSupportedProcessesInfo } from '../../transactions/transaction';

const PAGE_SIZE = 50;

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const buyerDashboardSlice = createSlice({
  name: 'BuyerDashboardPage',
  initialState: {
    fetchInProgress: false,
    fetchError: null,
    transactionRefs: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadDataThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchError = null;
      })
      .addCase(loadDataThunk.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.transactionRefs = entityRefs(action.payload.data.data || []);
      })
      .addCase(loadDataThunk.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchError = action.payload;
      });
  },
});

export default buyerDashboardSlice.reducer;

const loadDataPayloadCreator = (_args, { dispatch, rejectWithValue, extra: sdk }) => {
  const processNames = getSupportedProcessesInfo().map(p => p.name);

  return sdk.transactions
    .query({
      only: 'order',
      processNames,
      page: 1,
      perPage: PAGE_SIZE,
      include: ['listing', 'provider', 'provider.profileImage'],
      'fields.transaction': [
        'lastTransition',
        'lastTransitionedAt',
        'payinTotal',
        'payoutTotal',
        'createdAt',
        'processName',
        'protectedData',
        'metadata',
        'lineItems',
      ],
      'fields.listing': ['title', 'price', 'publicData'],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'limit.images': 0,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => rejectWithValue(storableError(e)));
};

export const loadDataThunk = createAsyncThunk(
  'BuyerDashboardPage/loadData',
  loadDataPayloadCreator
);

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  return dispatch(loadDataThunk({ params, search }));
};
